import { render } from "./MagicLinkForm.vue?vue&type=template&id=ea88e58a&scoped=true"
import script from "./MagicLinkForm.vue?vue&type=script&lang=js"
export * from "./MagicLinkForm.vue?vue&type=script&lang=js"

import "./MagicLinkForm.vue?vue&type=style&index=0&id=ea88e58a&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea88e58a"]])

export default __exports__